// extracted by mini-css-extract-plugin
export default {"templateKeyValuePanel":"OAYpM1"};